import { render, staticRenderFns } from "./news_category.vue?vue&type=template&id=4102d780&scoped=true&"
import script from "./news_category.vue?vue&type=script&lang=js&"
export * from "./news_category.vue?vue&type=script&lang=js&"
import style0 from "./news_category.vue?vue&type=style&index=0&id=4102d780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4102d780",
  null
  
)

export default component.exports